module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"play":"Play video"},"lt":{"play":"Žiūrėti video įrašą"},"pl":{"play":"Włącz wideo"}}')
  delete Component.options._Ctor
}
